import { Users, BookOpen, Target, Heart, Shield, Star, Award } from "lucide-react";

export function MethodologySection() {
  const methodologies = [
    {
      title: "Educación Tradicional",
      description: "Mantenemos un enfoque educativo tradicional con disciplina y compromiso, valorando el esfuerzo y la perseverancia como pilares del aprendizaje.",
      icon: <BookOpen className="h-8 w-8" />,
      color: "bg-blue-500"
    },
    {
      title: "Valores Fundamentales",
      description: "Inculcamos respeto, liderazgo y responsabilidad en cada estudiante, formando no solo buenos alumnos sino también excelentes ciudadanos.",
      icon: <Heart className="h-8 w-8" />,
      color: "bg-red-500"
    },
    {
      title: "Clases Presenciales",
      description: "Ofrecemos educación 100% presencial, priorizando la interacción directa entre profesores y alumnos para un aprendizaje más efectivo y personalizado.",
      icon: <Users className="h-8 w-8" />,
      color: "bg-green-500"
    }
  ];

  const values = [
    { name: "Respeto", icon: <Target className="h-5 w-5" /> },
    { name: "Responsabilidad", icon: <Shield className="h-5 w-5" /> },
    { name: "Excelencia", icon: <Star className="h-5 w-5" /> },
    { name: "Compromiso", icon: <Award className="h-5 w-5" /> }
  ];

  return (
    <section id="metodologia" className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-custom mb-4">Metodología y Valores</h2>
          <div className="w-24 h-1 bg-primary-custom mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Nuestro enfoque educativo combina métodos tradicionales con técnicas modernas para formar estudiantes integrales y preparados para los desafíos del futuro.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {methodologies.map((method, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 relative overflow-hidden group"
            >
              <div className={`absolute top-0 right-0 w-32 h-32 ${method.color} opacity-10 rounded-bl-full transition-opacity duration-300 group-hover:opacity-20`}></div>
              <div className={`w-16 h-16 ${method.color} rounded-full flex items-center justify-center text-white mb-6 relative z-10`}>
                {method.icon}
              </div>
              <h3 className="text-xl font-semibold text-primary-custom mb-4">{method.title}</h3>
              <p className="text-justify text-gray-700">
                {method.description}
              </p>
            </div>
          ))}
        </div>
        <div className="bg-primary-custom rounded-2xl p-8 md:p-12 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-bl-full"></div>
          <div className="relative z-10">
            <h3 className="text-2xl md:text-3xl font-bold mb-6">Nuestros Valores Fundamentales</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-8">
              {values.map((value, index) => (
                <div key={index} className="flex items-center gap-3 bg-white/10 p-4 rounded-lg backdrop-blur-sm">
                  <div className="bg-white/20 p-2 rounded-full">
                    {value.icon}
                  </div>
                  <span className="font-medium">{value.name}</span>
                </div>
              ))}
            </div>
            <p className="text-white/90 max-w-3xl">
              En I.E.P. San Isidro, creemos que la educación va más allá de los conocimientos académicos.
              Formamos personas íntegras con valores sólidos que les permitirán enfrentar los desafíos de la vida
              con determinación y ética.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
